import React from 'react'
import { BusinessesAndAddresses } from './businessesAndAddresses/businessesAndAddresses'
import styles from './Registry.module.scss'
import { RegistryMatches } from './registryMatches/registryMatches'
import { useCSVExportCallback } from './utils'
import { Button } from 'uikit/buttons/default/button'

const dataIcon = require('./icons/data.svg') as string

const Registry = () => {
  const onCSVExport = useCSVExportCallback()

  return (
    <div className={styles.registry}>
      <div className={styles.exportButtonContainer}>
        <Button type='primary' onClick={onCSVExport}>
          Export
        </Button>
      </div>
      <div className={styles.registryContent}>
        <RegistryMatches />
        <div className={styles.sectionDivider}>
          <div className={styles.sectionDividerLine} />
          <div className={styles.sectionDividerContent}>
            <img src={dataIcon} alt='' className={styles.sectionDividerIcon} />
            <span className={styles.sectionDividerText}>Raw Data Collection</span>
          </div>
          <div className={styles.sectionDividerLine} />
        </div>
        <BusinessesAndAddresses />
      </div>
    </div>
  )
}

export default Registry
